import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallPen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      d="M10.148 3.094a1.167 1.167 0 0 1 1.56.08l1.118 1.117.08.089a1.17 1.17 0 0 1 0 1.472l-.08.088-6.885 6.883c-.219.22-.516.342-.824.342H3.334a.5.5 0 0 1-.5-.5v-1.783c0-.31.122-.606.342-.825l6.883-6.884zm-6.314 9.07h1.283a.16.16 0 0 0 .116-.047v-.001l6.886-6.883.021-.026a.17.17 0 0 0 0-.183l-.021-.026-1.117-1.117a.17.17 0 0 0-.21-.022l-.026.022-6.884 6.883v.002a.16.16 0 0 0-.049.116z"
      color="#323232"
    />
    <path
      d="M8.813 4.42a.5.5 0 0 1 .67-.035l.037.035 2.06 2.06.034.038a.5.5 0 0 1-.703.703l-.038-.034-2.06-2.06-.034-.038a.5.5 0 0 1 .034-.669"
      color="#323232"
    />
  </svg>
);
export default SvgSmallPen;
